import { render, staticRenderFns } from "./TeamStatisticsTemplate.vue?vue&type=template&id=2b067771"
import script from "./TeamStatisticsTemplate.vue?vue&type=script&lang=js"
export * from "./TeamStatisticsTemplate.vue?vue&type=script&lang=js"
import style0 from "./TeamStatisticsTemplate.vue?vue&type=style&index=0&id=2b067771&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports